import { createAsyncThunk } from '@reduxjs/toolkit';
import endOfWeek from 'date-fns/endOfWeek';
import startOfWeek from 'date-fns/startOfWeek';

import { driverAPI } from '@/modules/driver/api';
import { IDriverWorkload } from '@/modules/driver/model/driver-workload';
import { namespace } from '@/modules/driver/namespace';

import { setDriverWorkload } from '../actions';

interface IParams {
  driverId: string;
  from?: Date | null | undefined;
  to?: Date | null | undefined;
}

let lastRequestId: string | undefined;

const loadWorkload = createAsyncThunk(
  `${namespace}/load-workload`,
  async ({ driverId, from, to }: IParams, { dispatch, requestId }) => {
    if (lastRequestId !== undefined) {
      return { isAlreadyExecuted: true };
    }

    lastRequestId = requestId;

    let workload: IDriverWorkload | undefined;

    try {
      workload = await driverAPI.loadWorkload({
        driverId,
        from: from ? from : startOfWeek(new Date(), { weekStartsOn: 1 }),
        to: to ? to : endOfWeek(new Date(), { weekStartsOn: 1 }),
      });

      dispatch(setDriverWorkload(workload));
    } finally {
      lastRequestId = undefined;
    }

    return workload ? { workload } : {};
  },
);

export { loadWorkload };
